export enum EnvironmentNameType {
    Local = 'local',
    Test = 'test',
    Dev = 'dev',
    Staging = 'staging',
    Production = 'prod',
}
